import { useScreenQuery } from 'playup-web-core';
import React from 'react';
import styled from 'styled-components';

const FormSection = ({ title, children }: Props) => {
	const { isSmall } = useScreenQuery();
	return (
		<FormSectionWrapper>
			{title && (
				<FormSectionHeader>
					{title}
					<Border />
				</FormSectionHeader>
			)}
			{children}
		</FormSectionWrapper>
	);
};

export default FormSection;

interface Props {
	title?: string;
	children: React.ReactNode;
}

const FormSectionWrapper = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	borderRadius: '5px',
	background: theme.colors.white,
	padding: '10px',
	margin: '5px 20px',
}));

const FormSectionHeader = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	paddingTop: '15px',
	fontWeight: 'bold',
	transform: 'uppercase',
	color: theme.colors.darkR,
}));

const Border = styled.div(({ theme }) => ({
	width: '90px',
	marginTop: '15px',
	marginBottom: '10px',
	borderBottom: '1px solid',
	borderColor: theme.colors.lightGreyR,
}));
